import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import {
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
} from "@mui/material";
import { IconBackgroundDelete, DeleteIcon } from "components/icon";
import { Close as CloseIcon } from "components/icon/mui_icon";
import { StyledButton, StyledDialog } from "customStyled";
import { FormFooter } from "Reuse/UI";
import { useTranslation } from "react-i18next";

function SimpleDialog(props) {
  const { t } = useTranslation();
  const { onClose, open, title, subTitle } = props;

  const handleClose = () => {
    onClose(null);
  };

  const handleDeleteClick = (value) => {
    onClose("submit");
  };

  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <IconBackgroundDelete>
          <DeleteIcon sx={{ color: "#BC1B06" }} />
        </IconBackgroundDelete>
        <IconButton
          sx={{ position: "absolute", top: 16, right: 16 }}
          onClick={handleClose}
          aria-label={t("close")}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ width: 400 }}>
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
        <Typography gutterBottom>{subTitle}</Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ paddingY: 2, gap: 2, paddingRight: 1.5 }}>
        <FormFooter
          backText={t("cancel")}
          backClick={handleClose}
          pathText={t("delete")}
          pathColor="error"
          handleSubmit={handleDeleteClick}
        />

      </DialogActions>
    </StyledDialog>
  );
}

const DeleteDialog = (props) => {
  const { t } = useTranslation();
  const {
    onSubmit = () => null,
    onCancel = () => null,
    fetchFunc = null,
    isShowOpen = true,
  } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = async (e) => {
    e.preventDefault();
    if(!isShowOpen) {
      return onSubmit();
    }
    if (!!fetchFunc) {
      const res = await fetchFunc();
      if (!res) {
        return;
      }
    }
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    if (value === null) {
      onCancel();
    } else {
      onSubmit();
    }
  };

  return (
    <React.Fragment>
      {props.buttonText ? (
        <StyledButton
          variant="text"
          startIcon={<DeleteIcon />}
          onClick={handleClickOpen}
          sx={{
            color: "#BC1B06",
            flexDirection: "row",
            alignSelf: "flex-start",
            zIndex: 11,
          }}
        >
          {props.buttonText}
        </StyledButton>
      ) : (
        <IconButton
          sx={{ zIndex: 11 }}
          onClick={handleClickOpen}
          aria-label={typeof props.title === "string" ? props.title : t("delete")}
        >
          <DeleteIcon sx={{ color: "#BC1B06" }} />
        </IconButton>
      )}
      <SimpleDialog open={open} onClose={handleClose} {...props} />
    </React.Fragment>
  );
};

export default DeleteDialog;
